import React from "react";
import PropTypes from "prop-types";

class Footer extends React.Component {
    render() {
        return (
            <footer className="footer">
                <span>© Bloomberg - </span>
                <a ref="tos" href={ this.props.bloombergSiteUrl + "/notices/tos/" }>Terms of Service</a>
                <span> - </span>
                <a ref="privacy" href={ this.props.bloombergSiteUrl + "/notices/privacy/" }>Privacy Policy</a>
                <span> - </span>
                <a ref="feedback" href={ this.props.bloombergSiteUrl + "/feedback" }>Feedback</a>
            </footer>
        );
    }
}

Footer.propTypes = {
    bloombergSiteUrl: PropTypes.string.isRequired
};

export default Footer;
